import React from 'react';

const CalorVesselsNotice = () => (
  <section className="mb-8 border border-red-500/40 bg-red-500/10 rounded-lg p-6" role="note" aria-label="Calor Vessels">
    <h3 className="text-2xl font-bold mb-4 text-white underline decoration-red-500 decoration-2 underline-offset-4">
      CALOR VESSELS
    </h3>
    <div className="space-y-3 text-pvs-text-muted">
      <p>
        This applies solely to refurbishment, inspection, and re-certification work undertaken on
        Calor owned or Calor controlled vessels under instruction from Calor.
      </p>
      <p>
        All such work shall be carried out strictly in accordance with the current controlled
        version of CAL515 and applicable issued local work instructions.
      </p>
      <p>
        Refurbishment, inspection, re-certification, reporting, and release activities shall only
        be undertaken by personnel who are currently approved Vessel Inspectors by Calor for the
        relevant activity. Personnel must not undertake work outside the limits of their Calor
        approval.
      </p>
      <p>
        Where this document conflicts with a Calor controlled document or instruction, the Calor
        controlled document or instruction shall take precedence.
      </p>
      <p>
        No deviation from the applicable Calor process, inspection requirement, rejection criteria,
        repair method, or certification requirement may be made without prior written approval from
        Calor. Where the applicable instruction is unavailable, unclear, out of date, or does not
        address the condition found, work shall be stopped and referred to Calor for further
        instruction.
      </p>
      <p>
        All inspection findings, records, reports, and re-certification documentation shall be
        completed using the format and process specified by Calor and retained/submitted in
        accordance with Calor’s document control and record retention requirements.
      </p>
    </div>
  </section>
);

export default CalorVesselsNotice;
